import React from 'react'
import "./HeroStyles.css"

const Hero = (props) => {
  return (
    <div>
      <div className={props.cName}>
        <img src={props.heroImg} alt="" loading='lazy' />
        <div className="grad">
          <div className="hero-text">
            <h1>{props.headingText}</h1>
            <p>{props.paraText}</p>
            <a className='link-text' href={props.url} >{props.linkText}</a>
          </div>
        </div>

      </div>
    </div>
  )
}

export default Hero
